var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondAboutImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 302,
    viewBox: "0 0 318 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.736 251.291C306.771 240.441 309.004 228.375 310.549 216.653C314.809 184.339 313.112 151.09 303.783 119.65C282.522 47.9544 241.634 5.14895 189.837 0.501263C138.041 -4.14642 88.4289 23.7122 69.3452 76.308C50.2616 128.904 -3.71261 172.775 5.55443 215.587C14.8215 258.4 55.1733 287.778 134.771 297.596C169.449 301.865 206.153 303.783 240.301 295.21C259.79 290.308 278.949 280.827 292.118 266.093C296.032 261.658 299.273 256.67 301.736 251.291Z",
    fill: "#C0D3E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M301.736 251.291C306.771 240.441 309.004 228.375 310.549 216.653C314.809 184.339 313.112 151.09 303.783 119.65C282.522 47.9544 241.634 5.14895 189.837 0.501263C138.041 -4.14642 88.4289 23.7122 69.3452 76.308C50.2616 128.904 -3.71261 172.775 5.55443 215.587C14.8215 258.4 55.1733 287.778 134.771 297.596C169.449 301.865 206.153 303.783 240.301 295.21C259.79 290.308 278.949 280.827 292.118 266.093C296.032 261.658 299.273 256.67 301.736 251.291Z",
    fill: "#C0D3E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M308.228 267.44H317",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8413 267.44H302.938",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 267.44H44.1958",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.181 57.9099H157.007V68.0922H167.181V57.9099Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.486 72.7926L177.82 79.4875L184.51 87.1594L192.175 80.4645L185.486 72.7926Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.236 27.4152L120.571 34.1101L127.26 41.7819L134.926 35.087L128.236 27.4152Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.236 68.6647L120.571 75.3596L127.26 83.0314L134.926 76.3365L128.236 68.6647Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M173.573 26.9545L165.908 33.6494L172.597 41.3212L180.263 34.6263L173.573 26.9545Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.137 75.0225L168.301 79.3951L173.124 80.0964L169.634 83.4997L170.458 88.3055L166.137 86.0366L161.83 88.3055L162.647 83.4997L159.165 80.0964L163.98 79.3951L166.137 75.0225Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.406 43.9944L131.563 48.3671L136.385 49.0683L132.895 52.4716L133.72 57.2843L129.406 55.0086L125.092 57.2843L125.916 52.4716L122.426 49.0683L127.249 48.3671L129.406 43.9944Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M193.093 19.7315L191.609 24.3792L194.59 28.2362L189.72 28.2568L186.972 32.2857L185.447 27.6587L180.769 26.2905L184.698 23.4029L184.554 18.5283L188.511 21.3816L193.093 19.7315Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.594 96.8031L165.43 97.4012L168.665 93.7573L169.593 98.5425L174.058 100.502L169.792 102.86L169.318 107.714L165.753 104.38L160.999 105.432L163.06 101.011L160.594 96.8031Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187.758 63.1129C188.67 59.2667 186.293 55.4095 182.45 54.4974C178.607 53.5854 174.753 55.964 173.842 59.8101C172.931 63.6563 175.307 67.5135 179.15 68.4255C182.993 69.3376 186.847 66.959 187.758 63.1129Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.101 112.085C160.893 109.29 160.893 104.758 158.101 101.963C155.308 99.1678 150.78 99.1678 147.987 101.963C145.195 104.758 145.195 109.29 147.987 112.085C150.78 114.88 155.308 114.88 158.101 112.085Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M205.468 46.0536C209.168 44.6686 211.044 40.5447 209.661 36.8425C208.277 33.1402 204.156 31.2617 200.457 32.6466C196.758 34.0316 194.881 38.1555 196.265 41.8578C197.649 45.56 201.769 47.4385 205.468 46.0536Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M156.622 50.2776C157.533 46.4315 155.157 42.5743 151.314 41.6622C147.471 40.7502 143.617 43.1288 142.706 46.9749C141.794 50.8211 144.171 54.6783 148.014 55.5903C151.857 56.5024 155.711 54.1238 156.622 50.2776Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150.034 70.4779L138.604 63.2864L138.102 76.7894L150.034 70.4779Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M203.562 65.6376L201.378 52.3064L190.936 60.8661L203.562 65.6376Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M154.376 95.6275L154.919 82.1313L142.966 88.4085L154.376 95.6275Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M189.246 50.2301L189.789 36.7271L177.836 43.0111L189.246 50.2301Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.575 24.386L149.616 35.9158L156.073 24.0491L142.575 24.386Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53217 187.433H60.4976L60.4976 155.291H2.53217L2.53217 187.433Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29779 187.433H62.2632L62.2632 155.291H4.29779L4.29779 187.433Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5144 160.248L23.897 176.928H43.1318L33.5144 160.248Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M316.395 213.036H258.43V245.178H316.395V213.036Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M314.631 213.036H256.666V245.178H314.631V213.036Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M284.617 219.142L287.688 225.377L294.557 226.374L289.584 231.228L290.758 238.076L284.617 234.845L278.469 238.076L279.643 231.228L274.67 226.374L281.539 225.377L284.617 219.142Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M147.761 155.903C147.761 155.903 125.353 162.146 124.405 164.291C123.457 166.436 110.762 189.448 110.762 189.448L122.062 205.831L131.783 193.188L135.286 223.226C135.286 223.226 130.999 230.246 132.538 233.367C133.463 235.226 134.968 236.732 136.825 237.657H187.886C187.886 237.657 191.005 233.951 190.222 229.077C189.439 224.202 188.079 218.152 188.079 218.152L187.886 200.964L193.732 183.019L222.378 182.827L217.529 162.73C217.529 162.73 197.648 158.44 196.288 157.656C194.928 156.873 188.099 155.511 184.788 155.511H175.432L149.513 155.319L147.761 155.903Z",
    fill: "#EEF9EF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M127.62 177.058L131.783 193.153L123.986 179.107",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M126.129 171.311L126.816 173.951",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M120.07 186.608L116.78 184.766",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M131.782 193.153L121.828 187.591",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M198.04 167.021L193.753 183.012L202.326 167.021",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M209.635 173.311L212.266 171.703",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M193.753 183.012L206.778 175.051",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M172.45 208.093L174.848 206.223",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M145.618 229.042L170.589 209.544",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M159.646 215.581L145.618 225.529",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M152.44 141.857L151.272 157.265L162.765 170.142L172.706 157.849L169.587 142.641L152.44 141.857Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M169.585 142.641L152.412 141.857L152.13 145.749C154.692 148.726 159.824 155.236 161.898 155.759C163.636 156.192 168.081 151.194 170.588 147.598L169.585 142.641Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M149.32 147.907L160.037 161.555L152.632 175.793L145.81 156.096L149.32 147.907Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M174.456 147.907L163.74 161.555L171.145 175.793L177.967 156.096L174.456 147.907Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M145.624 121.767C145.624 121.767 143.481 117.285 141.537 120.791C139.593 124.297 145.824 131.31 146.634 131.31C147.445 131.31 145.624 121.767 145.624 121.767Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M176.613 121.767C176.613 121.767 178.757 117.285 180.735 120.791C182.714 124.297 176.421 131.31 175.638 131.31C174.855 131.31 176.613 121.767 176.613 121.767Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M144.285 106.944C144.436 110.141 145.57 132.665 147.383 137.374C149.327 142.441 158.292 150.637 162.579 150.245C166.865 149.853 174.47 140.296 175.446 136.79C176.318 133.634 177.039 111.4 177.177 106.944H144.285Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M149.327 124.889C149.327 124.889 152.075 127.818 157.124 124.696",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M173.494 124.889C173.494 124.889 170.746 127.818 165.697 124.696",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M159.076 132.5C159.076 132.5 161.02 136.206 165.314 132.5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M160.243 139.127H163.754",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M148.16 119.622C148.16 119.622 149.534 118.247 156.541 119.43",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M173.687 119.622C173.687 119.622 172.314 118.247 165.313 119.43",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M222.2 162.146C222.2 162.146 243.241 117.869 245.384 117.677C247.528 117.484 250.063 120.427 249.286 124.304C248.51 128.182 237.794 165.687 235.458 173.456C233.122 181.225 229.997 184.374 227.469 183.404C224.941 182.435 222.2 162.146 222.2 162.146Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M102.82 189.406C102.82 189.406 113.578 213.862 116.079 213.429C118.579 212.996 126.026 205.563 126.335 204.133C126.644 202.703 121.718 194.639 116.717 190.953C111.716 187.268 110.116 185.962 109.346 186.093C108.577 186.223 104.043 188.595 102.82 189.406Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M215.77 160.778C215.77 160.778 213.826 173.841 215.578 179.114C217.33 184.388 219.088 185.158 222.008 185.35C224.927 185.543 229.221 184.766 229.997 182.82C230.773 180.874 223.766 161.754 222.983 160.386C222.2 159.018 218.305 159.217 215.77 160.778Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9996 183.521C64.4413 182.45 62.8194 181.474 61.1428 180.599C61.1428 180.599 58.0309 179.754 57.3371 176.907C56.6433 174.061 60.6482 173.167 60.6482 173.167C63.2106 173.119 106.805 191.882 106.805 191.882C114.196 200.297 115.509 210.163 115.735 211.51C115.777 211.754 115.767 212.004 115.707 212.244C115.646 212.484 115.536 212.708 115.383 212.903C115.23 213.097 115.038 213.257 114.82 213.373C114.601 213.488 114.361 213.556 114.114 213.573C113.345 213.704 100.258 207.887 96.3494 205.77C88.0509 201.266 68.4383 185.075 68.4383 185.075L65.9996 183.521Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2497 189.833C46.2497 189.833 44.3812 192.7 42.4234 193.958C40.4655 195.216 37.8826 196.02 38.7069 196.598C39.5313 197.175 40.5068 197.56 42.5264 196.66C44.5461 195.759 46.9229 194.81 46.9229 194.81C46.9229 194.81 49.0388 189.173 46.2497 189.833Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8718 190.809C45.8718 190.809 44.1132 196.378 41.8943 198.22C39.6755 200.063 36.4743 201.521 38.5351 201.885C40.596 202.249 41.8806 201.307 44.6628 199.554C47.4449 197.801 48.2899 196.385 47.8846 193.002C47.4793 189.619 47.0259 189.152 45.8718 190.809Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0642 188.774C46.0642 188.774 45.8993 195.161 45.4734 197.959C45.0475 200.758 39.7991 206.031 42.0386 206.21C44.2781 206.388 48.1457 200.613 49.0387 198.461C49.9318 196.309 50.5844 195.828 49.8974 193.951C49.2105 192.074 46.6069 186.684 46.0642 188.774Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3528 211.934C67.8698 208.109 67.6225 202.154 63.8005 198.634C59.9785 195.115 54.0291 195.362 50.5121 199.187C46.9951 203.012 47.2424 208.967 51.0644 212.487C54.8864 216.007 60.8358 215.759 64.3528 211.934Z",
    fill: "#C0D3E9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7018 174.831C64.7018 174.831 58.8902 171.661 56.1698 173.765C53.4495 175.869 47.3356 185.625 45.3228 187.632C43.31 189.64 47.0745 194.597 48.366 198.915C49.6575 203.232 48.6202 206.677 50.8459 205.928C53.0716 205.178 52.1511 202.978 52.3022 198.592C52.4534 194.205 50.6879 190.341 50.7772 189.778C50.8665 189.214 55.2493 186.278 58.107 187.027C60.9648 187.777 62.3868 189.729 62.2288 191.943C62.0708 194.157 60.4358 200.427 61.267 202.098C62.0982 203.769 63.6302 204.229 64.5507 201.163C65.4712 198.097 67.9374 192.404 68.4526 190.163C68.9678 187.921 63.9324 177.691 63.9324 177.691",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7018 174.831C64.7018 174.831 58.8902 171.661 56.1698 173.765C53.4495 175.869 47.3356 185.625 45.3228 187.632C43.31 189.64 47.0745 194.597 48.366 198.915C49.6575 203.232 48.6202 206.677 50.8459 205.928C53.0716 205.178 52.1511 202.978 52.3022 198.592C52.4534 194.205 50.6879 190.341 50.7772 189.778C50.8665 189.214 55.2493 186.278 58.107 187.027C60.9648 187.777 62.3868 189.729 62.2288 191.943C62.0708 194.157 60.4358 200.427 61.267 202.098C62.0982 203.769 63.6302 204.229 64.5507 201.163C65.4712 198.097 67.9374 192.404 68.4526 190.163C68.9678 187.921 63.9324 177.691 63.9324 177.691",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5216 213.607C50.7983 212.55 49.4611 210.965 48.7079 209.087C47.9547 207.21 47.8256 205.14 48.3396 203.183C48.8536 201.226 49.9834 199.487 51.5618 198.223C53.1403 196.959 55.0834 196.237 57.1036 196.165",
    fill: "#C0D3E9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5216 213.607C50.7983 212.55 49.4611 210.965 48.7079 209.087C47.9547 207.21 47.8256 205.14 48.3396 203.183C48.8536 201.226 49.9834 199.487 51.5618 198.223C53.1403 196.959 55.0834 196.237 57.1036 196.165",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M266.571 124.696C266.571 124.696 269.559 126.346 271.881 126.518C274.203 126.69 276.854 126.188 276.401 127.096C275.948 128.003 275.268 128.787 273.062 128.959C270.857 129.131 268.309 129.399 268.309 129.399C268.309 129.399 263.795 125.432 266.571 124.696Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M267.36 125.377C267.36 125.377 271.537 129.461 274.36 130.032C277.183 130.602 280.694 130.382 279.052 131.682C277.41 132.981 275.823 132.754 272.546 132.52C269.27 132.287 267.855 131.434 266.618 128.265C265.382 125.095 265.546 124.469 267.36 125.377Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M266.227 123.679C266.227 123.679 269.387 129.234 271.076 131.496C272.766 133.758 279.89 135.931 278.022 137.113C276.153 138.296 269.998 135.051 268.191 133.586C266.385 132.122 265.595 131.998 265.313 130.018C265.031 128.038 264.791 122.091 266.227 123.679Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M269.628 137.429H255.126V151.943H269.628V137.429Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M243.221 120.186C243.221 120.186 246.855 114.645 250.241 115.222C253.628 115.8 263.63 121.527 266.344 122.324C269.057 123.122 268.089 129.289 268.982 133.703C269.875 138.117 272.416 140.668 270.101 141.059C267.786 141.451 267.56 139.072 265.361 135.277C263.163 131.482 262.888 127.24 262.552 126.786C262.215 126.333 256.953 125.81 254.803 127.873C252.653 129.935 252.302 132.287 253.491 134.157C254.679 136.027 259.076 140.784 259.124 142.654C259.172 144.525 258.045 145.652 255.792 143.383C253.539 141.114 248.675 137.257 247.15 135.497C245.625 133.737 245.254 122.366 245.254 122.366",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M243.221 120.186C243.221 120.186 246.855 114.645 250.241 115.222C253.628 115.8 263.63 121.527 266.344 122.324C269.057 123.122 268.089 129.289 268.982 133.703C269.875 138.117 272.416 140.668 270.101 141.059C267.786 141.451 267.56 139.072 265.361 135.277C263.163 131.482 262.888 127.24 262.552 126.786C262.215 126.333 256.953 125.81 254.803 127.873C252.653 129.935 252.302 132.287 253.491 134.157C254.679 136.027 259.076 140.784 259.124 142.654C259.172 144.525 258.045 145.652 255.792 143.383C253.539 141.114 248.675 137.257 247.15 135.497C245.625 133.737 245.254 122.366 245.254 122.366",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M262.407 137.436H269.627V144.765",
    fill: "#92E3A9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M262.407 137.436H269.627V144.765",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M136.846 237.623L133.411 250.521L96.5488 248.926C96.5488 248.926 118.827 267.241 129.694 270.926C140.562 274.612 155.421 278.627 167.882 277.561C180.344 276.495 192.544 274.123 204.978 268.004C217.412 261.885 224.9 249.957 224.9 249.957H189.611L187.907 237.581L136.846 237.623Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M189.385 267.31C189.385 267.31 197.862 267.936 203.969 266.361C210.076 264.787 214.479 267.798 215.036 273.498C215.592 279.198 212.741 284.436 205.164 285.007C197.587 285.578 186.76 280.614 186.76 280.614C186.76 280.614 183.793 272.975 189.385 267.31Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M197.964 284.079C197.964 284.079 204.977 285.763 208.35 282.305C211.723 278.847 212.403 273.869 211.346 269.93C211.08 268.947 210.552 268.056 209.819 267.351C209.086 266.646 208.174 266.154 207.183 265.928C211.572 265.976 214.581 268.836 215.035 273.491C215.591 279.198 212.74 284.43 205.163 285C202.245 285.112 199.328 284.771 196.514 283.99L197.964 284.079Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M187.034 269.675C187.034 269.675 191.273 271.559 194.763 271.456C198.252 271.353 199.716 274.454 197.511 276.619C195.305 278.785 186.258 276.241 185.461 275.698C184.664 275.155 184.932 271.27 187.034 269.675Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M147.451 247.448C134.108 241.623 121.259 234.726 109.03 226.822C102.717 222.655 96.3967 221.074 90.9422 225.529C85.4878 229.984 85.7763 239.754 90.2209 244.78C94.6656 249.806 108.46 254.839 121.526 260.304C134.591 265.77 161.005 272.082 168.616 274.096C176.228 276.111 178.378 277.403 180.247 279.129C182.115 280.855 186.759 280.635 186.759 280.635C186.759 280.635 186.711 274.818 188.002 272.082C189.294 269.345 190.153 267.489 190.153 267.489C190.153 267.489 187.858 265.763 185.701 264.182C183.544 262.601 182.953 263.749 178.522 260.875C173.604 257.699 167.572 255.794 162.166 253.649C157.275 251.69 152.356 249.627 147.451 247.448Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M124.116 268.816C124.116 268.816 115.625 268.286 109.793 265.901C103.961 263.515 99.1865 265.901 97.8606 271.47C96.5348 277.039 98.6575 282.621 106.104 284.21C113.551 285.798 124.927 282.353 124.927 282.353C124.927 282.353 128.884 275.203 124.116 268.816Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M113.338 284.279C113.338 284.279 106.159 284.966 103.288 281.116C100.416 277.266 100.416 272.178 101.996 268.472C102.39 267.534 103.033 266.721 103.855 266.121C104.677 265.521 105.647 265.157 106.661 265.069C102.305 264.526 98.9392 266.946 97.8606 271.484C96.5348 277.059 98.6575 282.635 106.104 284.224C108.979 284.727 111.915 284.785 114.808 284.395L113.338 284.279Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M126.122 271.49C126.122 271.49 121.67 272.783 118.222 272.178C114.773 271.573 112.912 274.481 114.787 276.922C116.663 279.363 125.991 278.07 126.85 277.644C127.709 277.218 127.984 273.361 126.122 271.49Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M134.455 266.705C134.455 266.705 183.518 246.54 201.014 236.983C218.511 227.426 231.241 230.348 231.241 240.696C231.241 251.043 216.918 257.953 205.521 262.992C194.124 268.032 149.829 278.386 144.794 279.183C139.759 279.981 138.955 280.242 138.955 280.242C138.955 280.242 136.303 283.164 135.52 283.426C134.737 283.687 123.842 281.837 123.842 281.837C123.842 281.837 126.493 276.261 125.697 273.876C124.9 271.49 124.11 268.829 124.11 268.829C124.11 268.829 130.21 264.319 134.455 266.705Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M316.402 158.619H287.22V183.707H316.402V158.619Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M316.402 163.672H287.22V183.706H316.402V163.672Z",
    fill: "#B0B0B0",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M292.895 155.284H234.929V187.426H292.895V155.284Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M291.129 155.284H233.164V187.426H291.129V155.284Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M267.107 163.026H252.605V177.539H267.107V163.026Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52561 241.452H31.7075L31.7075 216.364H2.52561L2.52561 241.452Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52561 241.459H31.7075L31.7075 221.424H2.52561L2.52561 241.459Z",
    fill: "#B0B0B0",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0327 245.185H83.998V213.043H26.0327L26.0327 245.185Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7983 245.185H85.7637V213.043H27.7983L27.7983 245.185Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4819 236.222C68.2493 232.755 68.495 226.887 65.0308 223.117C61.5665 219.346 55.7041 219.1 51.9367 222.568C48.1693 226.035 47.9236 231.902 51.3879 235.673C54.8521 239.443 60.7146 239.689 64.4819 236.222Z",
    fill: "#C0D3E9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondAboutImage);
export default __webpack_public_path__ + "static/media/secondAboutImage.0ed5c852ba9fe85f10594812c4121429.svg";
export { ForwardRef as ReactComponent };